import React, { useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setNavbar, setOpenModal } from '../redux/Actions/UserAction';
import './Navbar.css';
import { useNavigate } from 'react-router-dom';
import hrlogo from '../app/assets/images/hrlogo.png';
import { useMediaQuery } from 'react-responsive';
import { Button } from '@mui/material';
import {
    BackMenu,
    PromptHire,
    PromptHireLogo,
} from '../app/assets/svgComponent';

function Navbar() {
    const username = localStorage.getItem('username');
    const navbar = useSelector((state) => state.user.navbar);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isMobile = useMediaQuery({
        query: '(max-width: 820px)',
    });
    const isiPadPro = useMediaQuery({
        query: '(max-width: 1024px)',
    });
    const [selectedItem, setSelectedItem] = useState(() => {
        const savedPath = localStorage.getItem('lastVisitedPath');
        return savedPath || window.location.pathname;
    });
    const [isProfileOpen, setIsProfileOpen] = useState(true);
    useLayoutEffect(() => {
        if (isMobile || isiPadPro) {
            dispatch(setNavbar(false));
        }
    }, [isMobile, isiPadPro]);
    useLayoutEffect(() => {
        setSelectedItem(window.location.pathname);
        dispatch(setOpenModal({ modalVisible: false }));
    }, [window.location.pathname]);
    const handleClick = (path) => {
        setSelectedItem(path);
        if (isMobile || isiPadPro) {
            dispatch(setNavbar(false));
        }
        navigate(path);
    };

    const onLogoutHandler = () => {
        const isConfirmed = window.confirm('Are you sure you want to logout?');
        if (isConfirmed) {
            localStorage.clear();
            navigate('/');
            window.location.reload();
        }
    };

    const isAgentYugaStaff =
        localStorage.getItem('isAgentYugaStaff') === 'true';

    return (
        <>
            <div
                onClick={() => dispatch(setNavbar(!navbar))}
                className={`sidebar-overlay  ${navbar ? 'open' : 'closed'}`}
            />
            <aside className={`sidebar  ${navbar ? 'open' : 'closed'}`}>
                <div
                    style={{
                        display: 'flex',
                        
                    }}
                >
                    <div className={`menubarOpen`}>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                margin: '10px 20px',
                                justifyContent: 'space-between',
                            }}
                        >
                            <div
                                style={{
                                    gap: 10,
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <img src={PromptHireLogo} />
                                <span
                                    style={{
                                        color: '#000000',
                                        fontSize: 14,
                                        fontWeight: '600',
                                        fontFamily: 'inter',
                                    }}
                                >
                                    PromptHire
                                </span>
                            </div>
                            <div
                                onClick={() => {
                                    dispatch(setNavbar(!navbar));
                                }}

                            >
                                <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{
                                        
                                        transform: navbar ? 'rotate(180deg)' : 'rotate(0deg)', 
                                        display: 'block', 
                                       position: 'relative', 
                                       transformOrigin: 'center', 

										cursor:"pointer",
                                         transition: 'transform 0.4s ease-in-out',
                                            
                                    }}
                                >
                                    <path
                                        d="M11.0833 1.75H2.91667C2.27233 1.75 1.75 2.27233 1.75 2.91667V11.0833C1.75 11.7277 2.27233 12.25 2.91667 12.25H11.0833C11.7277 12.25 12.25 11.7277 12.25 11.0833V2.91667C12.25 2.27233 11.7277 1.75 11.0833 1.75Z"
                                        stroke="#93939D"
                                        strokeWidth="1.25"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M8.75 1.75V12.25"
                                        stroke="#93939D"
                                        strokeWidth="1.25"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M5.83398 8.75L4.08398 7L5.83398 5.25"
                                        stroke="#93939D"
                                        strokeWidth="1.25"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </div>
                        </div>
                        <div style={{ marginTop: 34 }}>
                            {isAgentYugaStaff && (
                                <div
                                    onClick={() => handleClick('/organization')}
                                    className={`drawer-lable ${
                                        selectedItem === '/organization'
                                            ? 'selected'
                                            : ''
                                    }`}
                                >
                                    <svg
                                        width="15"
                                        height="15"
                                        viewBox="0 0 14 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        style={{ marginTop: '-2px' }}
                                    >
                                        <path
                                            d="M10.4965 4.90039H6.29648C5.52438 4.90039 4.89648 5.52829 4.89648 6.30039V11.9004H11.8965V6.30039C11.8965 5.52829 11.2686 4.90039 10.4965 4.90039ZM7.69648 9.80039C7.69648 10.1868 7.38358 10.5004 6.99648 10.5004C6.60938 10.5004 6.29648 10.1868 6.29648 9.80039V9.45039C6.29648 9.06399 6.60938 8.75039 6.99648 8.75039C7.38358 8.75039 7.69648 9.06399 7.69648 9.45039V9.80039ZM7.69648 7.35039C7.69648 7.73679 7.38358 8.05039 6.99648 8.05039C6.60938 8.05039 6.29648 7.73679 6.29648 7.35039V7.00039C6.29648 6.61399 6.60938 6.30039 6.99648 6.30039C7.38358 6.30039 7.69648 6.61399 7.69648 7.00039V7.35039ZM10.4965 9.80039C10.4965 10.1868 10.1836 10.5004 9.79648 10.5004C9.40938 10.5004 9.09648 10.1868 9.09648 9.80039V9.45039C9.09648 9.06399 9.40938 8.75039 9.79648 8.75039C10.1836 8.75039 10.4965 9.06399 10.4965 9.45039V9.80039ZM10.4965 7.35039C10.4965 7.73679 10.1836 8.05039 9.79648 8.05039C9.40938 8.05039 9.09648 7.73679 9.09648 7.35039V7.00039C9.09648 6.61399 9.40938 6.30039 9.79648 6.30039C10.1836 6.30039 10.4965 6.61399 10.4965 7.00039V7.35039Z"
                                            fill={
                                                selectedItem === '/organization'
                                                    ? '#2563EB'
                                                    : '#757582'
                                            }
                                        />
                                        <path
                                            d="M2.79883 11.9003V3.32812C2.79883 3.01592 3.00603 2.74082 3.30633 2.65472L6.80633 1.65442C7.25363 1.52632 7.69883 1.86232 7.69883 2.32782V3.49962"
                                            stroke={
                                                selectedItem === '/organization'
                                                    ? '#2563EB'
                                                    : '#757582'
                                            }
                                            stroke-width="1.25"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M2.09766 11.9004H11.8977"
                                            stroke={
                                                selectedItem === '/organization'
                                                    ? '#2563EB'
                                                    : '#757582'
                                            }
                                            stroke-width="1.25"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                    <span>Organization</span>
                                </div>
                            )}
                            <div
                                onClick={() => handleClick('/')}
                                className={`drawer-lable ${
                                    selectedItem === '/' ? 'selected' : ''
                                }`}
                            >
                                <svg
                                    width="15"
                                    height="15"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginTop: '-2px' }}
                                >
                                    <path
                                        d="M7.00156 4.19961H2.10156V3.14961C2.10156 2.57001 2.57196 2.09961 3.15156 2.09961H5.22706C5.46086 2.09961 5.67996 2.21651 5.80946 2.41111L7.00156 4.19961Z"
                                        fill={
                                            selectedItem === '/interview-list'
                                                ? '#2563EB'
                                                : '#757582'
                                        }
                                        stroke={
                                            selectedItem === '/'
                                                ? '#2563EB'
                                                : '#757582'
                                        }
                                        stroke-width="1.25"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M2.10156 4.19971H10.8516C11.4312 4.19971 11.9016 4.67011 11.9016 5.24971V9.79971C11.9016 10.9589 10.9608 11.8997 9.80156 11.8997H4.20156C3.04236 11.8997 2.10156 10.9589 2.10156 9.79971V4.19971Z"
                                        stroke={
                                            selectedItem === '/'
                                                ? '#2563EB'
                                                : '#757582'
                                        }
                                        stroke-width="1.25"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                                <span>Department</span>
                            </div>
                            <div
                                onClick={() => handleClick('/sub-department')}
                                className={`drawer-lable ${
                                    selectedItem === '/sub-department'
                                        ? 'selected'
                                        : ''
                                }`}
                            >
                                <svg
                                    width="15"
                                    height="15"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginTop: '-2px' }}
                                >
                                    <path
                                        d="M9.45156 4.19961H7.00156L5.80946 2.41111C5.67996 2.21651 5.46086 2.09961 5.22706 2.09961H3.15156C2.57196 2.09961 2.10156 2.57001 2.10156 3.14961V9.79961C2.10156 10.3463 2.31086 10.8433 2.65386 11.2171C2.47606 10.9231 2.39836 10.5654 2.48026 10.1958L3.25796 6.69581C3.40006 6.05531 3.96846 5.59961 4.62436 5.59961H10.5016V5.24961C10.5016 4.67001 10.0312 4.19961 9.45156 4.19961Z"
                                        fill={
                                            selectedItem === '/interview-list'
                                                ? '#2563EB'
                                                : '#757582'
                                        }
                                        stroke={
                                            selectedItem === '/sub-department'
                                                ? '#2563EB'
                                                : '#757582'
                                        }
                                        stroke-width="1.25"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M9.83125 11.8996H3.84765C2.95235 11.8996 2.28665 11.0701 2.48125 10.1958L3.25895 6.69581C3.40105 6.05531 3.96945 5.59961 4.62535 5.59961H10.609C11.5043 5.59961 12.17 6.42911 11.9754 7.30341L11.1977 10.8034C11.0556 11.4439 10.4872 11.8996 9.83125 11.8996Z"
                                        stroke={
                                            selectedItem === '/sub-department'
                                                ? '#2563EB'
                                                : '#757582'
                                        }
                                        stroke-width="1.25"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>

                                <span>Sub-Department</span>
                            </div>
                            <div
                                onClick={() => handleClick('/role')}
                                className={`drawer-lable ${
                                    selectedItem === '/role' ? 'selected' : ''
                                }`}
                            >
                                <svg
                                    width="15"
                                    height="15"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginTop: '-2px' }}
                                >
                                    <path
                                        d="M6.99844 1.40039C3.91074 1.40039 1.39844 3.91269 1.39844 7.00039C1.39844 10.0881 3.91074 12.6004 6.99844 12.6004C10.0861 12.6004 12.5984 10.0881 12.5984 7.00039C12.5984 3.91269 10.0861 1.40039 6.99844 1.40039ZM6.99844 4.20039C7.96304 4.20039 8.74844 4.98579 8.74844 5.95039C8.74844 6.91499 7.96304 7.70039 6.99844 7.70039C6.03384 7.70039 5.24844 6.91499 5.24844 5.95039C5.24844 4.98579 6.03384 4.20039 6.99844 4.20039ZM6.99844 11.2004C5.93304 11.2004 4.96284 10.7986 4.22154 10.1427C4.86554 9.28309 5.87424 8.75039 6.99844 8.75039C8.12264 8.75039 9.13204 9.28309 9.77534 10.1427C9.03404 10.7986 8.06314 11.2004 6.99844 11.2004Z"
                                        fill={
                                            selectedItem === '/role'
                                                ? '#2563EB'
                                                : '#757582'
                                        }
                                    />
                                </svg>
                                <span>Role</span>
                            </div>
                            <div
                                onClick={() => handleClick('/open-position')}
                                className={`drawer-lable ${
                                    selectedItem === '/open-position'
                                        ? 'selected'
                                        : ''
                                }`}
                            >
                                <svg
                                    width="15"
                                    height="15"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginTop: '-2px' }}
                                >
                                    <path
                                        d="M8.86473 5.4286C8.58428 5.4286 8.35667 5.20099 8.35667 4.92054V3.22699C8.35667 3.1335 8.28079 3.05763 8.18731 3.05763H5.81634C5.72286 3.05763 5.64699 3.1335 5.64699 3.22699V4.92054C5.64699 5.20099 5.41938 5.4286 5.13892 5.4286C4.85847 5.4286 4.63086 5.20099 4.63086 4.92054V3.22699C4.63086 2.57328 5.16263 2.0415 5.81634 2.0415H8.18731C8.84102 2.0415 9.3728 2.57328 9.3728 3.22699V4.92054C9.3728 5.20099 9.14518 5.4286 8.86473 5.4286Z"
                                        fill={
                                            selectedItem === '/open-position'
                                                ? '#2563EB'
                                                : '#757582'
                                        }
                                    />
                                    <path
                                        d="M12.4207 6.79644V6.2755C12.4207 5.24786 11.5855 4.4126 10.5578 4.4126H3.44493C2.41729 4.4126 1.58203 5.24786 1.58203 6.2755V6.79644C3.06152 7.57479 4.72729 8.03611 6.49332 8.11266V7.96905C6.49332 7.6886 6.72093 7.46099 7.00139 7.46099C7.28184 7.46099 7.50945 7.6886 7.50945 7.96905V8.11266C9.27548 8.03611 10.9413 7.57479 12.4207 6.79644Z"
                                        fill={
                                            selectedItem === '/open-position'
                                                ? '#2563EB'
                                                : '#757582'
                                        }
                                    />
                                    <path
                                        d="M7.50945 9.12915V9.4936C7.50945 9.77405 7.28184 10.0017 7.00139 10.0017C6.72093 10.0017 6.49332 9.77405 6.49332 9.4936V9.12915C4.74152 9.05937 3.08319 8.63599 1.58203 7.92334V10.6791C1.58203 11.7067 2.41729 12.542 3.44493 12.542H10.5578C11.5855 12.542 12.4207 11.7067 12.4207 10.6791V7.92334C10.9196 8.63531 9.26126 9.05937 7.50945 9.12915Z"
                                        fill={
                                            selectedItem === '/open-position'
                                                ? '#2563EB'
                                                : '#757582'
                                        }
                                    />
                                </svg>
                                <span>Job Opening</span>
                            </div>
                            <div
                                onClick={() => handleClick('/interview-list')}
                                className={`drawer-lable ${
                                    selectedItem === '/interview-list'
                                        ? 'selected'
                                        : ''
                                }`}
                            >
                                <svg
                                    width="15"
                                    height="15"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginTop: '-2px' }}
                                >
                                    <path
                                        d="M2.58594 4.4627L3.53094 5.4077L5.73594 2.8877"
                                        stroke={
                                            selectedItem === '/interview-list'
                                                ? '#2563EB'
                                                : '#757582'
                                        }
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M4.47594 8.24219H3.21594C2.868 8.24219 2.58594 8.52425 2.58594 8.87219V10.1322C2.58594 10.4801 2.868 10.7622 3.21594 10.7622H4.47594C4.82388 10.7622 5.10594 10.4801 5.10594 10.1322V8.87219C5.10594 8.52425 4.82388 8.24219 4.47594 8.24219Z"
                                        fill={
                                            selectedItem === '/interview-list'
                                                ? '#2563EB'
                                                : '#757582'
                                        }
                                        stroke={
                                            selectedItem === '/interview-list'
                                                ? '#2563EB'
                                                : '#757582'
                                        }
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M7.625 4.4624H11.405"
                                        stroke={
                                            selectedItem === '/interview-list'
                                                ? '#2563EB'
                                                : '#757582'
                                        }
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M7.625 9.50293H11.405"
                                        stroke={
                                            selectedItem === '/interview-list'
                                                ? '#2563EB'
                                                : '#757582'
                                        }
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                                <span>Interview List</span>
                            </div>
                            <div
                                onClick={() => handleClick('/applicant-list')}
                                className={`drawer-lable ${
                                    selectedItem === '/applicant-list'
                                        ? 'selected'
                                        : ''
                                }`}
                            >
                                <svg
                                    width="15"
                                    height="15"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginTop: '-2px' }}
                                >
                                    <path
                                        d="M4.54844 6.99971C5.32164 6.99971 5.94844 6.37291 5.94844 5.59971C5.94844 4.82651 5.32164 4.19971 4.54844 4.19971C3.77524 4.19971 3.14844 4.82651 3.14844 5.59971C3.14844 6.37291 3.77524 6.99971 4.54844 6.99971Z"
                                        fill={
                                            selectedItem === '/applicant-list'
                                                ? '#2563EB'
                                                : '#757582'
                                        }
                                        stroke={
                                            selectedItem === '/applicant-list'
                                                ? '#2563EB'
                                                : '#757582'
                                        }
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M9.44883 4.89961C10.222 4.89961 10.8488 4.27281 10.8488 3.49961C10.8488 2.72641 10.222 2.09961 9.44883 2.09961C8.67563 2.09961 8.04883 2.72641 8.04883 3.49961C8.04883 4.27281 8.67563 4.89961 9.44883 4.89961Z"
                                        fill={
                                            selectedItem === '/applicant-list'
                                                ? '#2563EB'
                                                : '#757582'
                                        }
                                        stroke={
                                            selectedItem === '/applicant-list'
                                                ? '#2563EB'
                                                : '#757582'
                                        }
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M12.7112 8.558C12.1904 7.186 10.9101 6.2998 9.44921 6.2998C8.39291 6.2998 7.43601 6.7681 6.78711 7.543C7.83571 8.082 8.67641 8.9927 9.11951 10.161C9.16011 10.2681 9.18391 10.3773 9.20841 10.4865C9.28891 10.49 9.36871 10.5005 9.44921 10.5005C10.3571 10.5005 11.265 10.2912 12.1659 9.8719C12.6636 9.6402 12.903 9.0634 12.7105 8.5587L12.7112 8.558Z"
                                        fill={
                                            selectedItem === '/applicant-list'
                                                ? '#2563EB'
                                                : '#757582'
                                        }
                                    />
                                    <path
                                        d="M7.81111 10.6576C7.29031 9.28561 6.01002 8.39941 4.54911 8.39941C3.08822 8.39941 1.80792 9.28561 1.28712 10.6576C1.09462 11.163 1.33402 11.7398 1.83172 11.9715C2.73332 12.3908 3.64052 12.6001 4.54842 12.6001C5.45632 12.6001 6.36421 12.3908 7.26512 11.9715C7.76281 11.7398 8.00221 11.163 7.80971 10.6583L7.81111 10.6576Z"
                                        fill={
                                            selectedItem === '/applicant-list'
                                                ? '#2563EB'
                                                : '#757582'
                                        }
                                    />
                                </svg>
                                <span>Applicants List</span>
                            </div>
                            {/* <div
                                onClick={() => handleClick('/candidate-list')}
                                className={`drawer-lable ${
                                    selectedItem === '/candidate-list'
                                        ? 'selected'
                                        : ''
                                }`}
                            >
                                <svg
                                    width="15"
                                    height="15"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginTop: '-2px' }}
                                >
                                    <path
                                        d="M7.00195 5.59961C7.96845 5.59961 8.75195 4.81611 8.75195 3.84961C8.75195 2.88311 7.96845 2.09961 7.00195 2.09961C6.03545 2.09961 5.25195 2.88311 5.25195 3.84961C5.25195 4.81611 6.03545 5.59961 7.00195 5.59961Z"
                                        fill={
                                            selectedItem === '/candidate-list'
                                                ? '#2563EB'
                                                : '#757582'
                                        }
                                        stroke={
                                            selectedItem === '/candidate-list'
                                                ? '#2563EB'
                                                : '#757582'
                                        }
                                        stroke-width="1.4"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M10.2654 11.5182C10.9283 11.3635 11.2937 10.6061 10.9591 10.0132C10.1793 8.63211 8.70022 7.69971 7.00062 7.69971C5.30102 7.69971 3.82192 8.63211 3.04212 10.0132C2.70752 10.6061 3.07292 11.3635 3.73582 11.5182C5.91282 12.0271 8.08912 12.0271 10.2661 11.5182H10.2654Z"
                                        fill={
                                            selectedItem === '/candidate-list'
                                                ? '#2563EB'
                                                : '#757582'
                                        }
                                        stroke={
                                            selectedItem === '/candidate-list'
                                                ? '#2563EB'
                                                : '#757582'
                                        }
                                        stroke-width="1.4"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                                <span>Candidates List</span>
                            </div> */}
                            {isAgentYugaStaff && (
                                <div
                                    onClick={() =>
                                        handleClick('/question-list')
                                    }
                                    className={`drawer-lable ${
                                        selectedItem === '/question-list'
                                            ? 'selected'
                                            : ''
                                    }`}
                                >
                                    <svg
                                        width="15"
                                        height="15"
                                        viewBox="0 0 14 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        style={{ marginTop: '-2px' }}
                                    >
                                        <path
                                            d="M2.79883 4.89961H4.89883C5.28523 4.89961 5.59883 4.58601 5.59883 4.19961V2.09961"
                                            fill={
                                                selectedItem ===
                                                '/question-list'
                                                    ? '#2563EB'
                                                    : '#757582'
                                            }
                                        />
                                        <path
                                            d="M2.79883 4.89961H4.89883C5.28523 4.89961 5.59883 4.58601 5.59883 4.19961V2.09961"
                                            stroke={
                                                selectedItem ===
                                                '/question-list'
                                                    ? '#2563EB'
                                                    : '#757582'
                                            }
                                            stroke-width="1.25"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M11.1988 9.79961V4.19961C11.1988 3.03971 10.2587 2.09961 9.09883 2.09961H5.88863C5.70313 2.09961 5.52463 2.17311 5.39373 2.30471L3.00393 4.69451C2.87233 4.82611 2.79883 5.00391 2.79883 5.18941V9.79961C2.79883 10.9595 3.73893 11.8996 4.89883 11.8996H9.09883C10.2587 11.8996 11.1988 10.9595 11.1988 9.79961Z"
                                            stroke={
                                                selectedItem ===
                                                '/question-list'
                                                    ? '#2563EB'
                                                    : '#757582'
                                            }
                                            stroke-width="1.25"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                    <span>Questions List</span>
                                </div>
                            )}
                            {/* <div
								onClick={() => handleClick("/report-card")}
								className={`drawer-lable ${selectedItem === "/report-card" ? "selected" : ""
									}`}
							>
								Report Card
							</div> */}
                        </div>

                        <div
                            style={{
                                position: 'absolute',
                                bottom: 20,
                                width: '100%',
                            }}
                        >
                            <div
                                style={{
                                    width: '198px',
                                    height: isProfileOpen ? '100px' : '40px',
                                    padding: '8px 0px 0px 0px',
                                    gap: '8px',
                                    borderRadius: '8px',
                                    background:
                                        'var(--White, rgba(255, 255, 255, 1))',
                                    boxShadow:
                                        '0px 0px 0px 1px rgba(218, 218, 221, 1)',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'flex-start',
                                    alignItems: 'center',
                                    marginLeft: '15px',
                                    overflow: 'hidden',
                                    transition: 'height 0.3s ease',
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        width: '100%',
                                        padding: '0 15px',
                                        justifyContent: 'space-between',
                                        marginLeft: '15px',
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                        }}
                                    >
                                        <svg
                                            width="18"
                                            height="18"
                                            viewBox="0 0 14 14"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M6.99844 1.40039C3.91074 1.40039 1.39844 3.91269 1.39844 7.00039C1.39844 10.0881 3.91074 12.6004 6.99844 12.6004C10.0861 12.6004 12.5984 10.0881 12.5984 7.00039C12.5984 3.91269 10.0861 1.40039 6.99844 1.40039ZM6.99844 4.20039C7.96304 4.20039 8.74844 4.98579 8.74844 5.95039C8.74844 6.91499 7.96304 7.70039 6.99844 7.70039C6.03384 7.70039 5.24844 6.91499 5.24844 5.95039C5.24844 4.98579 6.03384 4.20039 6.99844 4.20039ZM6.99844 11.2004C5.93304 11.2004 4.96284 10.7986 4.22154 10.1427C4.86554 9.28309 5.87424 8.75039 6.99844 8.75039C8.12264 8.75039 9.13204 9.28309 9.77534 10.1427C9.03404 10.7986 8.06314 11.2004 6.99844 11.2004Z"
                                                fill="blue"
                                            />
                                        </svg>
                                        <div
                                            style={{
                                                color: '#000000',
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                fontFamily: 'Inter',
                                            }}
                                        >
                                            {username}
                                        </div>
                                    </div>

                                    <div
                                        onClick={() =>
                                            setIsProfileOpen(!isProfileOpen)
                                        }
                                        style={{
                                            cursor: 'pointer',
                                            transform: isProfileOpen
                                                ? 'rotate(180deg)'
                                                : 'rotate(0deg)',
                                            transition: 'transform 0.3s ease',
                                            marginTop: '10px',
                                            marginRight: '15px',
                                        }}
                                    >
                                        <svg
                                            width="18"
                                            height="18"
                                            viewBox="0 0 14 14"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            style={{
                                                transform: isProfileOpen
                                                    ? 'translateY(5px)'
                                                    : 'translateY(-3px)',
                                            }}
                                        >
                                            <path
                                                d="M11.0833 1.75H2.91667C2.27233 1.75 1.75 2.27233 1.75 2.91667V11.0833C1.75 11.7277 2.27233 12.25 2.91667 12.25H11.0833C11.7277 12.25 12.25 11.7277 12.25 11.0833V2.91667C12.25 2.27233 11.7277 1.75 11.0833 1.75Z"
                                                stroke="#93939D"
                                                strokeWidth="1.25"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M8.75 1.75V12.25"
                                                stroke="#93939D"
                                                strokeWidth="1.25"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M5.83398 8.75L4.08398 7L5.83398 5.25"
                                                stroke="#93939D"
                                                strokeWidth="1.25"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </div>
                                </div>

                                <div
                                    style={{
                                        width: '90%',
                                        height: '1px',
                                        background: '#DADAEE',
                                        margin: '8px 0',
                                    }}
                                />

                                <div
                                    onClick={onLogoutHandler}
                                    style={{
                                        cursor: 'pointer',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        width: '100%',
                                        padding: '0 15px',
                                    }}
                                >
                                    <svg
                                        width="182"
                                        height="26"
                                        viewBox="0 0 182 26"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect
                                            width="182"
                                            height="26"
                                            rx="6"
                                            fill="#FEE7E7"
                                        />
                                        <path
                                            d="M17.9023 10.1996C17.9023 9.36307 17.4102 8.64767 16.7025 8.30957L14.6074 10.4047C14.4758 10.5363 14.4023 10.7141 14.4023 10.8996V15.0996C14.4023 15.2851 14.4758 15.4636 14.6074 15.5945L16.7025 17.6896C17.4102 17.3515 17.9023 16.6361 17.9023 15.7996V10.1996Z"
                                            fill="#DC2626"
                                        />
                                        <path
                                            d="M8.10156 12.9995H12.3016"
                                            stroke="#DC2626"
                                            stroke-width="1.25"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M11.209 16.8804C11.5772 17.4887 12.238 17.8996 13.001 17.8996H15.801C16.9609 17.8996 17.901 16.9595 17.901 15.7996V10.1996C17.901 9.03971 16.9609 8.09961 15.801 8.09961H13.001C12.2387 8.09961 11.5779 8.50911 11.2104 9.11671"
                                            stroke="#DC2626"
                                            stroke-width="1.25"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M10.0266 11.2495L8.10156 12.9995L10.0266 14.7495"
                                            stroke="#DC2626"
                                            stroke-width="1.25"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M27.0568 17V8.27273H28.1136V16.0625H32.1705V17H27.0568ZM36.2295 17.1364C35.6386 17.1364 35.1202 16.9957 34.6741 16.7145C34.231 16.4332 33.8844 16.0398 33.6344 15.5341C33.3872 15.0284 33.2636 14.4375 33.2636 13.7614C33.2636 13.0795 33.3872 12.4844 33.6344 11.9759C33.8844 11.4673 34.231 11.0724 34.6741 10.7912C35.1202 10.5099 35.6386 10.3693 36.2295 10.3693C36.8205 10.3693 37.3375 10.5099 37.7807 10.7912C38.2267 11.0724 38.5733 11.4673 38.8205 11.9759C39.0705 12.4844 39.1955 13.0795 39.1955 13.7614C39.1955 14.4375 39.0705 15.0284 38.8205 15.5341C38.5733 16.0398 38.2267 16.4332 37.7807 16.7145C37.3375 16.9957 36.8205 17.1364 36.2295 17.1364ZM36.2295 16.233C36.6784 16.233 37.0477 16.1179 37.3375 15.8878C37.6273 15.6577 37.8418 15.3551 37.981 14.9801C38.1202 14.6051 38.1898 14.1989 38.1898 13.7614C38.1898 13.3239 38.1202 12.9162 37.981 12.5384C37.8418 12.1605 37.6273 11.8551 37.3375 11.6222C37.0477 11.3892 36.6784 11.2727 36.2295 11.2727C35.7807 11.2727 35.4114 11.3892 35.1216 11.6222C34.8318 11.8551 34.6173 12.1605 34.4781 12.5384C34.3389 12.9162 34.2693 13.3239 34.2693 13.7614C34.2693 14.1989 34.3389 14.6051 34.4781 14.9801C34.6173 15.3551 34.8318 15.6577 35.1216 15.8878C35.4114 16.1179 35.7807 16.233 36.2295 16.233ZM43.2727 19.5909C42.7869 19.5909 42.3692 19.5284 42.0198 19.4034C41.6704 19.2812 41.3792 19.1193 41.1462 18.9176C40.9161 18.7188 40.7329 18.5057 40.5965 18.2784L41.3977 17.7159C41.4886 17.8352 41.6036 17.9716 41.7428 18.125C41.882 18.2812 42.0724 18.4162 42.3138 18.5298C42.5582 18.6463 42.8778 18.7045 43.2727 18.7045C43.8011 18.7045 44.2371 18.5767 44.5809 18.321C44.9246 18.0653 45.0965 17.6648 45.0965 17.1193V15.7898H45.0113C44.9374 15.9091 44.8323 16.0568 44.696 16.233C44.5624 16.4062 44.3692 16.5611 44.1164 16.6974C43.8664 16.831 43.5283 16.8977 43.1022 16.8977C42.5738 16.8977 42.0994 16.7727 41.6789 16.5227C41.2613 16.2727 40.9303 15.9091 40.686 15.4318C40.4445 14.9545 40.3238 14.375 40.3238 13.6932C40.3238 13.0227 40.4417 12.4389 40.6775 11.9418C40.9133 11.4418 41.2414 11.0554 41.6619 10.7827C42.0823 10.5071 42.5681 10.3693 43.1192 10.3693C43.5454 10.3693 43.8835 10.4403 44.1335 10.5824C44.3863 10.7216 44.5795 10.8807 44.713 11.0597C44.8494 11.2358 44.9545 11.3807 45.0283 11.4943H45.1306V10.4545H46.1022V17.1875C46.1022 17.75 45.9744 18.2074 45.7187 18.5597C45.4658 18.9148 45.1249 19.1747 44.696 19.3395C44.2698 19.5071 43.7954 19.5909 43.2727 19.5909ZM43.2386 15.9943C43.642 15.9943 43.9829 15.902 44.2613 15.7173C44.5397 15.5327 44.7513 15.267 44.8962 14.9205C45.0411 14.5739 45.1136 14.1591 45.1136 13.6761C45.1136 13.2045 45.0425 12.7884 44.9005 12.4276C44.7585 12.0668 44.5482 11.7841 44.2698 11.5795C43.9914 11.375 43.6477 11.2727 43.2386 11.2727C42.8124 11.2727 42.4573 11.3807 42.1732 11.5966C41.892 11.8125 41.6803 12.1023 41.5383 12.4659C41.3991 12.8295 41.3295 13.233 41.3295 13.6761C41.3295 14.1307 41.4005 14.5327 41.5425 14.8821C41.6874 15.2287 41.9005 15.5014 42.1817 15.7003C42.4658 15.8963 42.8181 15.9943 43.2386 15.9943ZM50.5022 17.1364C49.9113 17.1364 49.3928 16.9957 48.9468 16.7145C48.5036 16.4332 48.157 16.0398 47.907 15.5341C47.6599 15.0284 47.5363 14.4375 47.5363 13.7614C47.5363 13.0795 47.6599 12.4844 47.907 11.9759C48.157 11.4673 48.5036 11.0724 48.9468 10.7912C49.3928 10.5099 49.9113 10.3693 50.5022 10.3693C51.0931 10.3693 51.6102 10.5099 52.0533 10.7912C52.4994 11.0724 52.846 11.4673 53.0931 11.9759C53.3431 12.4844 53.4681 13.0795 53.4681 13.7614C53.4681 14.4375 53.3431 15.0284 53.0931 15.5341C52.846 16.0398 52.4994 16.4332 52.0533 16.7145C51.6102 16.9957 51.0931 17.1364 50.5022 17.1364ZM50.5022 16.233C50.9511 16.233 51.3204 16.1179 51.6102 15.8878C51.8999 15.6577 52.1144 15.3551 52.2536 14.9801C52.3928 14.6051 52.4624 14.1989 52.4624 13.7614C52.4624 13.3239 52.3928 12.9162 52.2536 12.5384C52.1144 12.1605 51.8999 11.8551 51.6102 11.6222C51.3204 11.3892 50.9511 11.2727 50.5022 11.2727C50.0533 11.2727 49.684 11.3892 49.3942 11.6222C49.1045 11.8551 48.89 12.1605 48.7508 12.5384C48.6116 12.9162 48.542 13.3239 48.542 13.7614C48.542 14.1989 48.6116 14.6051 48.7508 14.9801C48.89 15.3551 49.1045 15.6577 49.3942 15.8878C49.684 16.1179 50.0533 16.233 50.5022 16.233ZM59.0283 14.3239V10.4545H60.0339V17H59.0283V15.892H58.9601C58.8067 16.2244 58.568 16.5071 58.2442 16.7401C57.9203 16.9702 57.5112 17.0852 57.0169 17.0852C56.6078 17.0852 56.2442 16.9957 55.926 16.8168C55.6078 16.6349 55.3578 16.3622 55.176 15.9986C54.9942 15.6321 54.9033 15.1705 54.9033 14.6136V10.4545H55.9089V14.5455C55.9089 15.0227 56.0425 15.4034 56.3095 15.6875C56.5794 15.9716 56.9232 16.1136 57.3408 16.1136C57.5908 16.1136 57.845 16.0497 58.1036 15.9219C58.3649 15.794 58.5837 15.598 58.7598 15.3338C58.9388 15.0696 59.0283 14.733 59.0283 14.3239ZM64.6225 10.4545V11.3068H61.2305V10.4545H64.6225ZM62.2191 8.88636H63.2248V15.125C63.2248 15.4091 63.266 15.6222 63.3484 15.7642C63.4336 15.9034 63.5415 15.9972 63.6722 16.0455C63.8058 16.0909 63.9464 16.1136 64.0941 16.1136C64.2049 16.1136 64.2958 16.108 64.3668 16.0966C64.4379 16.0824 64.4947 16.071 64.5373 16.0625L64.7418 16.9659C64.6737 16.9915 64.5785 17.017 64.4563 17.0426C64.3342 17.071 64.1793 17.0852 63.9918 17.0852C63.7077 17.0852 63.4293 17.0241 63.1566 16.902C62.8867 16.7798 62.6623 16.5938 62.4833 16.3438C62.3072 16.0938 62.2191 15.7784 62.2191 15.3977V8.88636Z"
                                            fill="#DC2626"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </aside>
        </>
    );
}

export default Navbar;
